import { useTranslation } from "react-i18next";
import { Languages } from "lucide-react";
import { useState, useRef, useEffect } from "react";

const LANGUAGES = [
  { code: "it", label: "Italiano" },
  { code: "en", label: "English" },
  { code: "fr", label: "Français" },
  { code: "de", label: "Deutsch" },
  { code: "zh", label: "中文" },
];

export default function LanguageSelector({ variant = "light", placement = "auto" }) {
  const { i18n, t } = useTranslation();
  const [open, setOpen] = useState(false);
  const [openUp, setOpenUp] = useState(false);
  const ref = useRef(null);
  const btnRef = useRef(null);

  useEffect(() => {
    const h = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("click", h);
    return () => document.removeEventListener("click", h);
  }, []);

  // Detect available space when opening so we don't clip below the viewport
  // (the sidebar version sits near the bottom of the page).
  useEffect(() => {
    if (!open || !btnRef.current) return;
    if (placement === "up") { setOpenUp(true); return; }
    if (placement === "down") { setOpenUp(false); return; }
    const rect = btnRef.current.getBoundingClientRect();
    const spaceBelow = window.innerHeight - rect.bottom;
    setOpenUp(spaceBelow < 250); // 5 items × ~38px + padding
  }, [open, placement]);

  const current = LANGUAGES.find(l => l.code === i18n.language) || LANGUAGES[0];

  const base = variant === "dark"
    ? "text-stone-50 hover:bg-white/10 border-white/20"
    : "text-stone-700 hover:bg-stone-100 border-stone-300";

  return (
    <div ref={ref} className="relative">
      <button
        ref={btnRef}
        onClick={() => setOpen(!open)}
        data-testid="language-selector"
        className={`inline-flex items-center gap-2 text-xs px-3 py-2 border ${base} transition-colors`}
      >
        <Languages className="w-3.5 h-3.5" strokeWidth={1.5} />
        {current.code.toUpperCase()}
      </button>
      {open && (
        <div
          className={`absolute right-0 ${openUp ? "bottom-full mb-1" : "mt-1"} min-w-[160px] bg-white border border-stone-200 shadow-sm z-50`}
        >
          {LANGUAGES.map(l => (
            <button
              key={l.code}
              data-testid={`lang-${l.code}`}
              onClick={() => { i18n.changeLanguage(l.code); setOpen(false); }}
              className={`w-full text-left px-4 py-2 text-sm hover:bg-stone-50 ${l.code === current.code ? "text-blue-700 font-medium" : "text-stone-700"}`}
            >
              {l.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
